<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Pet Trainer Career Request
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.user_name"
                outlined
                readonly
                hide-details="auto"
                label="User Name"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.dob"
                outlined
                readonly
                hide-details="auto"
                label="Date of Birth"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.age"
                outlined
                readonly
                hide-details="auto"
                label="Age"
                prepend-inner-icon="mdi-calendar-account"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone_no"
                outlined
                readonly
                hide-details="auto"
                label="Phone Number"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                readonly
                hide-details="auto"
                label="Email"
                prepend-inner-icon="mdi-email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="genderText"
                outlined
                readonly
                hide-details="auto"
                label="Gender"
                prepend-inner-icon="mdi-gender-male-female"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.address"
                outlined
                readonly
                hide-details="auto"
                label="Address"
                prepend-inner-icon="mdi-map-marker"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.area"
                outlined
                readonly
                hide-details="auto"
                label="Area"
                prepend-inner-icon="mdi-map"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.pin_code"
                outlined
                readonly
                hide-details="auto"
                label="Pin Code"
                prepend-inner-icon="mdi-map-marker-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.preferred_timeslot"
                outlined
                readonly
                hide-details="auto"
                label="Preferred Timeslot"
                prepend-inner-icon="mdi-clock"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-textarea
                v-model="form.experience_description"
                outlined
                readonly
                hide-details="auto"
                label="Experience Description"
                prepend-inner-icon="mdi-text"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.trained_animal_type"
                outlined
                readonly
                hide-details="auto"
                label="Trained Animal Type"
                prepend-inner-icon="mdi-paw"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-textarea
                v-model="form.trained_animal_description"
                outlined
                readonly
                hide-details="auto"
                label="Trained Animal Description"
                prepend-inner-icon="mdi-text"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.language_spoken"
                outlined
                readonly
                hide-details="auto"
                label="Language Spoken"
                prepend-inner-icon="mdi-translate"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.other_language_spoken"
                outlined
                readonly
                hide-details="auto"
                label="Other Language Spoken"
                prepend-inner-icon="mdi-translate-off"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.available_on"
                outlined
                readonly
                hide-details="auto"
                label="Available On"
                prepend-inner-icon="mdi-calendar-check"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="allergiesText"
                outlined
                readonly
                hide-details="auto"
                label="Has Allergies"
                prepend-inner-icon="mdi-alert-circle"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.allergies_details"
                outlined
                readonly
                hide-details="auto"
                label="Allergies Details"
                prepend-inner-icon="mdi-text"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="outdoorComfortText"
                outlined
                readonly
                hide-details="auto"
                label="Comfortable Outdoor"
                prepend-inner-icon="mdi-nature"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="experienceText"
                outlined
                readonly
                hide-details="auto"
                label="Is Experienced"
                prepend-inner-icon="mdi-star"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="internetAccessText"
                outlined
                readonly
                hide-details="auto"
                label="Has Internet Access"
                prepend-inner-icon="mdi-wifi"
              ></v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-autocomplete
                v-model="form.status"
                outlined
                hide-details="auto"
                :items="statusItems"
                label="Status"
                prepend-inner-icon="mdi-checkbox-marked-circle-outline"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'pet_trainer_requests'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Pet Trainer Career Request
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "PetTrainerCareerRequestEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      statusItems: [
        { id: "PENDING", text: "PENDING", value: 0 },
        { id: "APPROVED", text: "APPROVED", value: 1 },
        { id: "REJECTED", text: "REJECTED", value: 2 },
      ],
      isLoading: false,
      isFetching: false,
    };
  },
  computed: {
    genderText() {
      if (this.form.gender === 0) return 'Male';
      if (this.form.gender === 1) return 'Female';
      if (this.form.gender === 2) return 'Other';
      return 'Not specified';
    },
    allergiesText() {
      return this.form.has_allergies ? 'YES' : 'NO';
    },
    outdoorComfortText() {
      return this.form.is_comfortable_outdoor ? 'YES' : 'NO';
    },
    experienceText() {
      return this.form.is_experienced ? 'YES' : 'NO';
    },
    internetAccessText() {
      return this.form.has_internet_access ? 'YES' : 'NO';
    }
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.petTrainerCareerRequestId;
      axios
        .get(`/pet_trainer_career_requests/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(`/pet_trainer_career_requests/${this.$route.params.petTrainerCareerRequestId}`, this.form)
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.push("/pet-trainer-career-requests");
          })
          .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>